
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.327 23.222a2.772 2.772 0 004.839 0c2.346-4.052 5.553-10.13 5.553-13.07 0-4.637-3.57-8.396-7.973-8.396-4.403 0-7.973 3.759-7.973 8.395 0 2.941 3.207 9.019 5.554 13.071zm2.42-8.873c2.2 0 3.986-1.88 3.986-4.198 0-2.318-1.785-4.197-3.987-4.197S7.76 7.834 7.76 10.15c0 2.319 1.784 4.198 3.986 4.198z","fill":"#1BBAC8"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.013 .91)","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    